<template>
  <section class="section" :aria-labelledby="headingId">
    <header v-if="title || $slots.title" class="section__header">
      <h2 :id="headingId" class="section__title">
        <slot name="title">{{ title }}</slot>
      </h2>
      <p v-if="lead" class="section__lead">{{ lead }}</p>
    </header>
    <div class="section__body">
      <slot></slot>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { nextUid } from '@/utils/uid';

const props = defineProps({
  title: { type: String, default: '' },
  lead: { type: String, default: '' },
});

const uid = nextUid('section');
const headingId = computed(() => (props.title ? uid : undefined));
</script>

<style scoped>
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.section__header {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.section__title {
  font-family: var(--font-display);
  font-size: var(--text-2xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-tight);
  /*
   * Tracking comes from the token, capped at 0.04em. These headings used
   * 0.2em — 6.4px on a 32px heading, wider than the word space, which is what
   * made Ukrainian headings read as "Я к   п о ч а т и". The landing's
   * wide-tracked look is Orbitron's own metrics, not letter-spacing.
   */
  letter-spacing: var(--tracking-display);
  color: var(--text);
  margin: 0;
  text-wrap: balance;
}

.section__lead {
  font-size: var(--text-lg);
  line-height: var(--leading-body);
  color: var(--text-muted);
  max-width: var(--measure);
  margin: 0;
}

.section__body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}
</style>
